import React from "react";
import _ from "lodash";
import { Route, NavLink, Redirect, Switch } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled, { css } from "styled-components";

import { MuiThemeProvider } from "@material-ui/core/styles";

import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
// import Drawer from '@material-ui/core/Drawer';

import IconProject from "@material-ui/icons/Domain";
import IconPeople from "@material-ui/icons/People";
import IconFacility from "@material-ui/icons/PinDrop";
import IconExitToApp from "@material-ui/icons/ExitToApp";
import IconHome from "@material-ui/icons/Home";

import adminTheme from "./theme";
import ProjectList from "./screens/Project";

import PeopleList from "./screens/PeopleList";
import Import from "./screens/Import";

import Facilities from "./screens/Facility";

import { primaryColor } from "./theme";
import Logo from "./components/LogoTheAgent";
import AppBar from "./components/AppBar";

import { signOut } from "../engine/auth";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  /* background: #fafafa; */
  background: #313131;
  box-sizing: border-box;
`;

const Main = styled.div`
  height: 100vh;
  padding-top: 64px;
  display: flex;
`;

const BrandHeader = styled.div`
  background: #333;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;

  svg {
    width: 80%;
  }
  hr {
    width: 100%;
    margin: 20px 0;
  }
`;

const Sidebar = styled.div`
  flex: 0 0 240px;
  display: flex;
  border-right: 1px solid #121212;
  flex-direction: column;
  justify-content: flex-start;
  height: calc(100vh - 64px);

  .sidebar-main {
    flex: 1 0 50%;
  }

  .theagent-logo {
    opacity: 0.5;
  }
  .theagent-logo path,
  .theagent-logo polygon {
    fill: white;
  }
`;

const Content = styled.div`
  flex-grow: 1;
  padding: 40px;
  box-sizing: border-box;
  overflow: scroll;
  margin-bottom: 40px;
`;

const StyledMenuItem = styled(MenuItem)`
  &&& {
    color: #aaa;
    span {
      color: inherit;
    }
    svg {
      fill: #aaa;
    }
    &:hover {
      color: ${primaryColor};
      svg {
        fill: ${primaryColor};
      }
    }

    &.active {
      background: ${primaryColor};
      color: white;
      svg {
        fill: white;
      }
    }

    ${(props) =>
      props.selected &&
      css`
        background: ${primaryColor};
        color: white;
        svg {
          fill: white;
        }
      `}
  }
`;

export default class extends React.Component {
  render() {
    const { match, user, auth, classes } = this.props;
    return (
      <MuiThemeProvider theme={adminTheme}>
        <Helmet>
          <title>Admin | MI Treasure</title>
        </Helmet>
        <Wrapper>
          <AppBar />
          <Main>
            <Sidebar>
              <BrandHeader>
                <Logo className="theagent-logo" />
              </BrandHeader>
              <div className="sidebar-main">
                <MenuList>
                  <StyledMenuItem
                    button
                    component={NavLink}
                    to={`${match.url}/projects`}
                  >
                    <ListItemIcon>
                      <IconProject />
                    </ListItemIcon>
                    <ListItemText>Projects</ListItemText>
                  </StyledMenuItem>
                  <StyledMenuItem
                    button
                    component={NavLink}
                    to={`${match.url}/facilities`}
                  >
                    <ListItemIcon>
                      <IconFacility />
                    </ListItemIcon>
                    <ListItemText>Facilities</ListItemText>
                  </StyledMenuItem>
                  <StyledMenuItem
                    button
                    component={NavLink}
                    to={`${match.url}/people`}
                  >
                    <ListItemIcon>
                      <IconPeople />
                    </ListItemIcon>
                    <ListItemText>People</ListItemText>
                  </StyledMenuItem>
                  <StyledMenuItem
                    button
                    component={NavLink}
                    to={`${match.url}/import`}
                  >
                    <ListItemIcon>
                      <IconHome />
                    </ListItemIcon>
                    <ListItemText>Import</ListItemText>
                  </StyledMenuItem>
                </MenuList>
              </div>
              <MenuList>
                <StyledMenuItem button onClick={signOut}>
                  <ListItemIcon>
                    <IconExitToApp color="action" />
                  </ListItemIcon>
                  <ListItemText inset>
                    Logout
                  </ListItemText>
                </StyledMenuItem>
              </MenuList>
            </Sidebar>
            <Content>
              <Switch>
                <Route
                  path={`${match.url}`}
                  exact
                  render={() => <Redirect to={`${match.url}/projects`} />}
                />
                <Route path={`${match.url}/projects`} component={ProjectList} />
                <Route
                  path={`${match.url}/people`}
                  render={(routerProps) => (
                    <PeopleList {...routerProps} user={user} auth={auth} />
                  )}
                />
                <Route
                  path={`${match.url}/facilities`}
                  render={(routerProps) => (
                    <Facilities {...routerProps} user={user} auth={auth} />
                  )}
                />
                <Route
                  path={`${match.url}/import`}
                  render={(routerProps) => (
                    <Import {...routerProps} user={user} auth={auth} />
                  )}
                />
                <Route
                  path={`${match.url}/*`}
                  render={() => <Redirect to={`${match.url}/projects`} />}
                />
              </Switch>
            </Content>
          </Main>
        </Wrapper>
      </MuiThemeProvider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/index.js